import { createSlice } from '@reduxjs/toolkit';

import { actionOnMessage } from '@skynet/data-ws-mm';
import { parseResponse } from '@skynet/data-ws-core';

import type { SupportedTokensState, SupportedTokens } from './types';
import { SupportedTokensCommands } from './types';

const allowedCommands = Object.values(SupportedTokensCommands);

export const initialState: SupportedTokensState = {
  data: null,
};

const supportedTokensSlice = createSlice({
  name: 'loansSupportedTokens',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(actionOnMessage, (state, action) => {
      const { json, skipProcessing } = parseResponse(action.payload, allowedCommands);

      if (skipProcessing || !json) return;

      const { command } = json;

      if (command === SupportedTokensCommands.SupportedTokens) {
        const { base, quote } = json as SupportedTokens & { command: string };
        state.data = {
          base: (base ?? []).map(String),
          quote: (quote ?? []).map(String),
        };
      }
    });
  },
});

export default supportedTokensSlice.reducer;
